<template>
  <div style='background-color: #fffbf6;'>
    <!-- 轮播图-->
    <carousel-page :type='3'></carousel-page>
    <!-- 轮播图结束 -->
    <!-- 业务介绍 -->
    <introduce-page :id='"yewujieshao"' :type='"业务介绍"' :url='"static/assets/images/train/01.png"'></introduce-page>
    <!-- 业务介绍结束 -->
    <!-- 业务亮点 -->
    <section id='yeliangdian' class="feature-area section-padding2" style='background-image: url("static/assets/images/train/bg.png");'>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderCDE' style='z-index: 100;position: relative;'>业务亮点</h2>
              <p class='titleShadow' style='z-index: 0;color: #caa4a4;'>BUSINESS HIGHLIGHTS</p>
            </div>
          </div>
        </div>
        <div class="row" style='justify-content: space-between;'>
          <div class="col-lg-4 pRelative" v-for='(item,index) in lightspotList' :key='index'>
            <img style='width: 100%;' :src="item.titleImage" alt="红色培训">
            <div class='trainLd'>
              <h4>{{item.title}}</h4>
              <p v-html='item.content'></p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 业务亮点结束 -->
    <!-- 学习精神-->
    <section id='xuexijianshen' class="feature-area section-padding2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderCDE' style='z-index: 100;position: relative;'>学习精神</h2>
              <p class='titleShadow' style='z-index: 0;'>LEARNING SPIRIT</p>
            </div>
          </div>
        </div>
        <div class="row" style='background-color: #fff;border-radius: 10px;box-shadow: 0px 0px 20px 0px rgba(179,33,33,0.1);padding: 20px 0px;'>
          <div class="col-lg-2" style='padding: 0;'>
            <div @click='pitchLearn=index' :class="pitchLearn==index?'cutLearnItem':'learnItem'" v-for="(item,index) in learnList" :key='index'>
              <div>{{item.title}}</div>
            </div>
          </div>
          <div class="col-lg-10">
            <div v-show='pitchLearn==index' class="" v-for="(item,index) in learnList" :key='index'>
              <div class='imgWarp'>
                <img mode='aspectFill' style='width: 49%;height: 380px;border-radius: 6px;' v-for='(nape,j) in item.titleImage.split(",")' :src="nape" :alt="item.title">
              </div>
              <p v-html='item.content'></p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 学习精神结束-->
    <!-- 课程安排-->
    <section id='kechenganpai' class="feature-area section-padding2"
      style='background-image: url("static/assets/images/train/bg02.png");background-size: 100% 100%;'>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderCDE' style='z-index: 100;position: relative;'>课程安排</h2>
              <p class='titleShadow' style='z-index: 0;color: #caa4a4;'>TEACHING HIGHLIGHT</p>
            </div>
          </div>
        </div>
        <div class="">
          <div class="row flexJCenter">
            <div  @click='showDiv(item.content)' class="col-lg-5 textCenter" style='margin-bottom: 20px;' v-for='(item,index) in courseInfo'>
              <img style='width: 100%;' :src="item.titleImage" :alt="item.title">
            </div>


          </div>


        </div>
      </div>
    </section>
    <!-- 课程安排结束-->
    <!-- 特色课程 -->
    <section id='tesekecheng' class="feature-area section-padding2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderCDE' style='z-index: 100;position: relative;'>特色课程</h2>
              <p class='titleShadow' style='z-index: 0;'>BUSINESS HIGHLIGHTS</p>
            </div>
          </div>
        </div>
        <div class="row" style='justify-content: space-between;'>
          <div @click='showDiv(item.content)' class="col-lg-4 pRelative" v-for='(item,index) in featureInfo' :key='index'>
            <img style='width: 100%;' :src="item.titleImage" :alt="item.title">
            <div class='trainKc'>
              <h4>{{item.title}}</h4>
            </div>
          </div>

        </div>
      </div>
    </section>
    <!-- 特色课程结束 -->
    <!-- 联系我们-->
    <contact-page  :id='"lianxiwomen"'></contact-page>

    <!-- 联系我们结束-->
    <!-- 放大-->
    <div v-show='isMagnify' class='isMagnifyDiv' @click='isMagnify=false'>
      <div class='magnifyDivContent'>
        <div v-html='htmlContent'></div>
      </div>

    </div>
    <!-- 锚点-->
    <div class='fbgWarp'>
      <div class='fbgTextWarp'>
        <div @click='cutIndex(0)' :class='cutFbgTextIndex==0?"cutFbgTextItem":"fbgTextItem"'>业务介绍</div>
        <div @click='cutIndex(1)' :class='cutFbgTextIndex==1?"cutFbgTextItem":"fbgTextItem"'>业务亮点</div>
        <div @click='cutIndex(2)' :class='cutFbgTextIndex==2?"cutFbgTextItem":"fbgTextItem"'>学习精神</div>
        <div @click='cutIndex(3)' :class='cutFbgTextIndex==3?"cutFbgTextItem":"fbgTextItem"'>课程安排</div>
        <div @click='cutIndex(4)' :class='cutFbgTextIndex==4?"cutFbgTextItem":"fbgTextItem"'>特色课程</div>
        <div @click='cutIndex(5)' :class='cutFbgTextIndex==5?"cutFbgTextItem":"fbgTextItem"'>联系我们</div>
      </div>
    </div>
  </div>
</template>
<script>
  import carouselPage from './module/carousel3.vue'
  import contactPage from './module/contact.vue'
  import introducePage from './module/introduceEctypal.vue'
  export default {
    components: {
      carouselPage,
      contactPage,
      introducePage
    },
    data() {
      return {
        lightspotList: [],
        learnList:null,
        pitchLearn:0,
        courseInfo:null,
        featureInfo:null,
        cutFbgTextIndex:0,
        htmlContent:null,
        isMagnify:false,
      }
    },
    created(){
      // this.$router.go(0);
    },
    watch: {
       $route(to, from) {
           this.$router.go(0);
       },
    },
    beforeCreate() {
      // this.$router.go(0);
    },
    beforeMount() {
      // this.$router.go(0);
    },
    methods:{
      showDiv(info){
        this.isMagnify = true
        this.htmlContent = info
      },
      cutIndex(index){
        this.cutFbgTextIndex = index
        if(index == 0){
          const mainRoot = document.getElementById("yewujieshao");
          mainRoot.scrollIntoView({ behavior: "smooth" });
        }else if(index == 1){
          const yeliangdian = document.getElementById("yeliangdian");
          yeliangdian.scrollIntoView({ behavior: "smooth" });
        }else if(index == 2){
          const xuexijiangshen = document.getElementById("xuexijianshen");
          xuexijiangshen.scrollIntoView({ behavior: "smooth" });
        }else if(index == 3){
          const kechenganpai = document.getElementById("kechenganpai");
          kechenganpai.scrollIntoView({ behavior: "smooth" });
        }else if(index == 4){
          const tesekecheng = document.getElementById("tesekecheng");
          tesekecheng.scrollIntoView({ behavior: "smooth" });
        }else if(index == 5){
          const lianxiwomen = document.getElementById("lianxiwomen");
          lianxiwomen.scrollIntoView({ behavior: "smooth" });
        }
      }
    },

    mounted() {
      console.log('==========this.$router====================',this.$router.currentRoute.path)
      console.log('==========this.$router====================',this.$router)
      this.$http({
        method: 'get',
        url: 'http://123.57.1.182/website/api/website/article/list?type=业务亮点',
        data: {}
      }).then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.lightspotList = res.data.data
        }
      })
      this.$http({
        method: 'get',
        url: 'http://123.57.1.182/website/api/website/article/list?type=学习精神',
        data: {}
      }).then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.learnList = res.data.data
        }
      })
      this.$http({
        method: 'get',
        url: 'http://123.57.1.182/website/api/website/article/list?type=课程安排',
        data: {}
      }).then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.courseInfo = res.data.data
        }
      })
      this.$http({
        method: 'get',
        url: 'http://123.57.1.182/website/api/website/article/list?type=特色课程',
        data: {}
      }).then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.featureInfo = res.data.data
        }
      })
    },
  }
</script>



// WEBPACK FOOTER //
// Train.vue?06e8f8d8